import { HrpBaseClient } from './HrpBaseClient'

export class HrpBillClient extends HrpBaseClient {
  constructor(
    hrpProxyApiUrl = process.env.HRP_PROXY_API_URL,
    hrpProxySecretName = process.env.HRP_PROXY_SECRET_NAME,
    axiosOptions
  ) {
    super(hrpProxyApiUrl, hrpProxySecretName, axiosOptions);
  }

  async getClaimBillsWaitingForFunding() {
    await this.createSecureAxiosInstance();

    try {
      const response = await this.secureAxiosInstance.get(
        `/admin/api/bill/db/getClaimBillsWaitingForFunding`
      );

      return response.data;
    } catch (e) {
      throw e.response;
    }
  }
}
